/* eslint-disable @angular-eslint/prefer-inject */
import { EquipmentTypeDataService } from '../infrastructure/equipment-types/equipment-type.data.service';
import {
    EquipmentTypeCreate,
    EquipmentTypeDto,
    EquipmentTypeRead,
    EquipmentTypeSearchParams,
} from '../entities/equipment-type.dto';
import { EquipmentTypeStore } from '../infrastructure/equipment-types/equipment-type.store';
import { Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { EquipmentTypeMapper } from '../infrastructure/equipment-types/equipment-type.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { ResourceAuth } from '@control-tower/platform-wms';

@Injectable()
export class EquipmentTypeFacade extends AbstractManageEntityFacade<
    EquipmentTypeDto,
    EquipmentTypeRead,
    EquipmentTypeCreate,
    EquipmentTypeSearchParams
> {
    nameField: keyof EquipmentTypeDto = 'name';

    constructor(
        dataService: EquipmentTypeDataService,
        store: EquipmentTypeStore,
        mapper: EquipmentTypeMapper
    ) {
        super(dataService, null, store, mapper);
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField
    );

    override applyResourceAuth(body: EquipmentTypeCreate): void {
        body.resourceAuth = { allAuthorized: true } as ResourceAuth;
    }

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof EquipmentTypeDto, string>> {
        return { name: searchText };
    }
}
